export function convertStringDateToDate(stringDate: string) {
    if (stringDate.includes("T")) {
        return new Date(stringDate);
    }

    return new Date(stringDate + "T00:00:00");
}
